export const USStatesWithRestrictions = ['PR', 'AS', 'GU']

export const isUSLocation = (country?: string) => country === 'US'

export const isLocationOutsideUS = (country?: string) => !!country && !isUSLocation(country)

export const isUSStateRestricted = (state?: string) => !!state && USStatesWithRestrictions.includes(state)
